<div id="{{appName}}-app" class="faq-dialog-content">
    <div mat-dialog-title>
        <div class="d-flex">
            <div>
                <h3>{{faqs.title}}</h3>
            </div>
            <div class="float-right ml-auto">
                <span class="fa fa-close action-icons" (click)="close()"></span>
            </div>
        </div>
    </div>
    <div mat-dialog-content>
        <span *ngIf="faqs.message" class="informationOrquestion">
            <div class="faqs-dialog information-text flow-content-text col-12">
                <span class="info-content" #informationtext [innerHTML]="faqs.message | safeHtml">
                </span>
            </div>
        </span>
    </div>
</div>